var firebaseConfig = {
            apiKey: "AIzaSyBPPmC69Vy4l76Ws88EIOyZg_EpgC_TEuM",
            authDomain: "nutrition-calculator-41c5f.firebaseapp.com",
            databaseURL: "https://nutrition-calculator-41c5f-9dde1.firebaseio.com",
            projectId: "nutrition-calculator-41c5f",
            storageBucket: "nutrition-calculator-41c5f.appspot.com",
            messagingSenderId: "1054746396982",
            appId: "1:1054746396982:web:d149b27cb54c9ef5facb97",
            measurementId: "G-Y42PJLQMKV"
        };
        firebase.initializeApp(firebaseConfig);

        var db = firebase.database();
        var data = [];
        var products = [];
        firebase.auth().signInAnonymously().then(function (user) {
            if (user) {
                db.ref().once("value").then(function (snapshot) {
                    data = snapshot.val();
                    console.log(data);
                    jQuery.each(data, function (index, obj) {
                        var options = "";
                        jQuery.each(obj.data, function (index, option) {
                            products.push({ value: obj.Type + "--" + option.Serving, text: option.Serving, type: obj.Type });

                            options += "<option value='" + option.Serving + "'>" + option.Serving + "</option>";
                        });

                        var $template = jQuery("#products-template").html();
                        $template = $template.replace("{ Label }", obj.Type).replace("{ ProductType }", obj.Type).replace("{ Options }", options);
                        jQuery("#products-used-section").append($template);
                    });

                    jQuery(".products-select").selectize({
                        create: false,
                        closeAfterSelect: true,
                        selectOnTab: false
                    });

                    jQuery("#ddlProducts").selectize({
                        create: false,
                        closeAfterSelect: true,
                        selectOnTab: false,
                        valueField: 'value',
                        labelField: 'text',
                        searchField: ['text'],
                        options: products
                    });
                });
            } else {
            }
        });

        //jQuery(".products-select:eq(0)")[0].selectize.items

        jQuery(document).ready(function () {

        });

        jQuery("#btnViewMore").on("click", function () {
            jQuery("#btnViewMoreOptions").slideToggle(300, function () {
                if (jQuery("#btnViewMoreOptions").is(":visible")) {
                    jQuery("#btnViewMore").text("View Less...");
                } else {
                    jQuery("#btnViewMore").text("View More...");
                }
            });
        });

        jQuery("#btnViewMoreProduct").on("click", function () {
            jQuery("#products-used-section").slideToggle(300, function () {
                if (jQuery("#products-used-section").is(":visible")) {
                    jQuery("#btnViewMoreProduct").text("View Less...");
                } else {
                    jQuery("#btnViewMoreProduct").text("View More...");
                }
            });
        });

        jQuery("#btnDownloadPdf").click(function () {
            generate_pdf();
        });

        jQuery("#btnCalculate").click(function () {
            jQuery("#tblResult tbody tr").remove();

            var selectedOptions = [];
            jQuery("#products-used-section select.products-select").each(function (index, element) {
                $select = jQuery(element);
                var producType = $select.data("product-type");
                var productTypeData = data[data.findIndex(x => x.Type == producType)].data;
                //console.log($select[0].selectize.items);

                jQuery.each($select[0].selectize.items, function (index, value) {
                    var selectedOption = jQuery.grep(productTypeData, function (obj, index) {
                        return obj.Serving == value;
                    });
                    selectedOptions.push(selectedOption[0]);
                });
            });

            jQuery.each(jQuery("#ddlProducts")[0].selectize.items, function (index, value) {
                var productType = value.split("--")[0];
                var productTypeData = data[data.findIndex(x => x.Type == productType)].data;
                var selectedOption = jQuery.grep(productTypeData, function (obj, index) {
                    return obj.Serving == value.split("--")[1];
                });
                selectedOptions.push(selectedOption[0]);
            });

            console.log(selectedOptions);

            jQuery.each(selectedOptions, function (index, obj) {
                var $template = jQuery("#result-template").html();
                var resultValue = jQuery($template).find(".txtProductServing").val();
				$template = $template.replace(/{ Product }/g, obj.Serving).replace(/{ Servings }/g, 1).replace(/{ Calories }/g, (replaceIfZero(obj.Calories, true))).replace(/{ Carbs }/g, (replaceIfZero(obj.Carbohydrates, true))).replace(/{ Sodium }/g, (replaceIfZero(obj.Sodium, true))).replace(/{ Protein }/g, (replaceIfZero(obj.Protein, true))).replace(/{ Sugar }/g, (replaceIfZero(obj.Sugar, true))).replace(/{ Potassium }/g, (replaceIfZero(obj.Potassium, true))).replace(/{ Calcium }/g, (replaceIfZero(obj.Calcium, true))).replace(/{ Magnesium }/g, (replaceIfZero(obj.Magnesium, true))).replace(/{ ServingSize }/g, obj["Serving size"]).replace(/{ Caffeine }/g, replaceIfZero((obj["Caffeine"] == undefined ? null : obj["Caffeine"]), true));
                jQuery("#tblResult tbody").append($template);
            });

            if (selectedOptions.length > 0) {
                jQuery("#results-section").fadeIn();
                CalculateTotal();

                jQuery('html, body').animate({
                    scrollTop: jQuery("#results-section").offset().top
                }, 500);
            }
        });

        function replaceIfZero(value, isLocale) {
            if (isLocale) {
                return (value == null ? "-" : Number(value));
            } else {
                return (value == 0 ? "-" : Number(value.toString().replace(/,/g, "")).toLocaleString());
            }
        }

        function convertNaNToZero(value) {
            return (value == "-" ? 0 : Number(value.toString().replace(/,/g, "")));
        }

        function calculateTableValue(qty, input) {
            return (qty == "-" ? "-" : Math.round(input * Number(qty)).toLocaleString());
        }

        jQuery(document).on("input", ".txtProductServing", function () {
            jQuery(this).attr("value", jQuery(this).val());
            var $tr = jQuery(this).closest("tr");
            var value = Number(jQuery(this).val());
            $tr.find(".calories").text(calculateTableValue($tr.find(".calories").attr("data-value"), value));
            $tr.find(".carbs").text(calculateTableValue($tr.find(".carbs").attr("data-value"), value));
            $tr.find(".sodium").text(calculateTableValue($tr.find(".sodium").attr("data-value"), value));
            $tr.find(".protein").text(calculateTableValue($tr.find(".protein").attr("data-value"), value));
            $tr.find(".sugar").text(calculateTableValue($tr.find(".sugar").attr("data-value"), value));
            $tr.find(".potassium").text(calculateTableValue($tr.find(".potassium").attr("data-value"), value));
            $tr.find(".calcium").text(calculateTableValue($tr.find(".calcium").attr("data-value"), value));
            $tr.find(".mg").text(calculateTableValue($tr.find(".mg").attr("data-value"), value));
            $tr.find(".caffeine").text(calculateTableValue($tr.find(".caffeine").attr("data-value"), value));

            CalculateTotal();
        });

        function SetColor(perHour, target) {
            if (target == "") {
                return "";
            }
            target = Number(target);
            var objPercent = {
                "10": [target - (target * 0.1), target + (target * 0.1)],
                "15": [target - (target * 0.15), target + (target * 0.15)],
            }

            if (perHour >= objPercent["10"][0] && perHour <= objPercent["10"][1]) {
                return "green";
            } else if (perHour >= objPercent["15"][0] && perHour <= objPercent["15"][1]) {
                return "orange"
            } else {
                return "red";
            }
        }

        function CalculateTotal() {
            var hours = Number(jQuery("#txtBikeDurationHours").val());
            var minutes = Number(jQuery("#txtBikeDurationMin").val());
            var totalMinutes = (hours * 60) + minutes;
            if (totalMinutes == 0) {
                totalMinutes = 1;
            }

            var totals = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
            jQuery("#tblResult tbody tr").each(function (index, element) {
                var $tr = jQuery(element);
                totals[0] += convertNaNToZero($tr.find(".txtProductServing").val());
                totals[1] += convertNaNToZero($tr.find(".calories").text());
                totals[2] += convertNaNToZero($tr.find(".carbs").text());
                totals[3] += convertNaNToZero($tr.find(".sodium").text());
                totals[4] += convertNaNToZero($tr.find(".protein").text());
                totals[5] += convertNaNToZero($tr.find(".sugar").text());
                totals[6] += convertNaNToZero($tr.find(".potassium").text());
                totals[7] += convertNaNToZero($tr.find(".calcium").text());
                totals[8] += convertNaNToZero($tr.find(".mg").text());
                totals[9] += convertNaNToZero($tr.find(".caffeine").text());
            });

            var $tfoot = jQuery("#tblResult tfoot tr:eq(0)");
            //$tfoot.find(".servings").text(replaceIfZero(totals[0]));
            $tfoot.find(".calories").text(replaceIfZero(totals[1]));
            $tfoot.find(".carbs").text(replaceIfZero(totals[2]));
            $tfoot.find(".sodium").text(replaceIfZero(totals[3]));
            $tfoot.find(".protein").text(replaceIfZero(totals[4]));
            $tfoot.find(".sugar").text(replaceIfZero(totals[5]));
            $tfoot.find(".potassium").text(replaceIfZero(totals[6]));
            $tfoot.find(".calcium").text(replaceIfZero(totals[7]));
            $tfoot.find(".mg").text(replaceIfZero(totals[8]));
            $tfoot.find(".caffeine").text(replaceIfZero(totals[9]));

            var totalPerHour = [
                totals[0],
                Math.round((totals[1] / totalMinutes) * 60),
                Math.round((totals[2] / totalMinutes) * 60),
                Math.round((totals[3] / totalMinutes) * 60),
                Math.round((totals[4] / totalMinutes) * 60),
                Math.round((totals[5] / totalMinutes) * 60),
                Math.round((totals[6] / totalMinutes) * 60),
                Math.round((totals[7] / totalMinutes) * 60),
                Math.round((totals[8] / totalMinutes) * 60),
                Math.round((totals[9] / totalMinutes) * 60)
            ];

            var targets = [
                totals[0],
                jQuery("#txtCaloriesPerHour").val(),
                jQuery("#txtCarbsPerHour").val(),
                jQuery("#txtSodiumPerHour").val(),
                jQuery("#txtProteinsPerHour").val(),
                jQuery("#txtSugarPerHour").val(),
                jQuery("#txtPotassiunPerHour").val(),
                jQuery("#txtCalciumPerHour").val(),
                jQuery("#txtMagnesiumPerHour").val(),
                jQuery("#txtCaffeinePerHour").val()
            ];

            var $tfootHour = jQuery("#tblResult tfoot tr:eq(1)");
            //$tfootHour.find(".servings").text(replaceIfZero(totals[0]));
            $tfootHour.find(".calories").css("color", SetColor(totalPerHour[1], targets[1])).text(replaceIfZero(totalPerHour[1]));
            $tfootHour.find(".carbs").css("color", SetColor(totalPerHour[2], targets[2])).text(replaceIfZero(totalPerHour[2]));
            $tfootHour.find(".sodium").css("color", SetColor(totalPerHour[3], targets[3])).text(replaceIfZero(totalPerHour[3]));
            $tfootHour.find(".protein").css("color", SetColor(totalPerHour[4], targets[4])).text(replaceIfZero(totalPerHour[4]));
            $tfootHour.find(".sugar").css("color", SetColor(totalPerHour[5], targets[5])).text(replaceIfZero(totalPerHour[5]));
            $tfootHour.find(".potassium").css("color", SetColor(totalPerHour[6], targets[6])).text(replaceIfZero(totalPerHour[6]));
            $tfootHour.find(".calcium").css("color", SetColor(totalPerHour[7], targets[7])).text(replaceIfZero(totalPerHour[7]));
            $tfootHour.find(".mg").css("color", SetColor(totalPerHour[8], targets[8])).text(replaceIfZero(totalPerHour[8]));
            $tfootHour.find(".caffeine").css("color", SetColor(totalPerHour[9], targets[9])).text(replaceIfZero(totalPerHour[9]));

            var $tfootTargets = jQuery("#tblResult tfoot tr:eq(2)");
            //$tfoot.find(".servings").text(jQuery("#").val());
            $tfootTargets.find(".calories").text(replaceIfZero(targets[1]));
            $tfootTargets.find(".carbs").text(replaceIfZero(targets[2]));
            $tfootTargets.find(".sodium").text(replaceIfZero(targets[3]));
            $tfootTargets.find(".protein").text(replaceIfZero(targets[4]));
            $tfootTargets.find(".sugar").text(replaceIfZero(targets[5]));
            $tfootTargets.find(".potassium").text(replaceIfZero(targets[6]));
            $tfootTargets.find(".calcium").text(replaceIfZero(targets[7]));
            $tfootTargets.find(".mg").text(replaceIfZero(targets[8]));
            $tfootTargets.find(".caffeine").text(replaceIfZero(targets[9]));
        }

        function generate_pdf() {
            var clone = jQuery("#result-section").clone();
            jQuery(clone).find("button").remove();
            jQuery(clone).find("#shareAndDownload").remove();
            clone = jQuery(clone).html();

            var element = document.createElement("div");
            element.id = "pdfDiv";
            //element.style.fontFamily = "Poppins, sans-serif";
            element.style.backgroundColor = "#fff";
            element.className = "calculator";
            element.innerHTML = clone;
            element.style.width = "1366px";
            //element.style.width = "1200px";
            element.style.height = jQuery("#result-section").height() + "px";

            jQuery("body").append(element);

            domtoimage.toPng(document.getElementById('pdfDiv')).then(function (dataUrl) {
                jQuery("#pdfDiv").remove();

                var link = document.createElement('a');
                link.download = 'results.jpeg';
                link.href = dataUrl;
                link.click();
            });
        }